export default {
  // Inhalt des Modals
  model: {
    id: 0,
    name: ''
  },

  name: 'undertakers',

  // Die Spalten der Tabelle
  cols: [
   {name: 'Name', json: 'name', type: 'text'}
  ],

  relations: [
    'deceaseds',
    'zips',
    'contact_types',
    'address_types'
  ],

  copy (aModel) {
    try {
      this.model.id = aModel.id
      this.model.kind_id = aModel.kind_id
      this.model.name = aModel.name
    } catch (e) {
      return false
    }

    return true
  },

  clear () {
    this.model.id = 0
    this.model.kind_id = -1
    this.model.name = ''
  },

  validate () {
    return true
  },

	validateModel () {
		return true
	},

	addresses: [],
  contacts: [],
  deceaseds: []
}



// WEBPACK FOOTER //
// ./src/models/undertakers.js